import { ProfileFilingRoute } from './ProfileFilingRoute';
import { ProfileGstRoute } from './ProfileGstRoute';
import { ProfileVoucherRoute } from './ProfileVoucherRoute';
import { useAuthStore } from '../stores/auth';
import { resolveProfile } from '../lib/profileAccess';
import { Route, Navigate } from 'react-router-dom';
import * as Pages from './routePages';
import { DEALER_LEDGER_ROLES } from '../lib/roles';
import { RequireRoles, RequireCapability, BlockReps, StrictViewBlock, RoleAwareHome, RoleAwareDashboard } from './routingGuards';
import { NoAccessPage } from '../components/auth/ProfileRouteGuard';


export function financeRoutes() {
  return <>
<Route path="/invoices" element={<Pages.InvoicesPage />} />
<Route path="/invoices/new" element={<Pages.InvoiceEditorPage />} />
<Route path="/invoices/:id" element={<Pages.InvoiceEditorPage />} />
<Route path="/invoices/:id/edit" element={<Pages.InvoiceEditorPage />} />
<Route path="/payments" element={<Pages.PaymentsPage />} />
<Route path="/credit-notes" element={<Pages.CreditNotesPage />} />
<Route path="/debit-notes" element={<Pages.DebitNotesPage />} />
<Route path="/accounting" element={<Pages.LedgerAccountingPage />} />
<Route path="/accounting/ledger" element={<Pages.LedgerAccountingPage />} />
<Route path="/accounting/legacy" element={<Pages.AccountingPage />} />
<Route path="/payment-confirmations" element={<Pages.PaymentConfirmationPage />} />
<Route
                  path="/accounting/suite/reports"
                  element={
                    <RequireRoles roles={['admin', 'owner', 'super_admin', 'accountant']}>
                      <Pages.ReportsHubPage />
                    </RequireRoles>
                  }
                />
<Route
                  path="/accounting/suite/payments"
                  element={
                    <RequireRoles roles={['admin', 'owner', 'super_admin', 'accountant']}>
                      <Pages.PaymentsHubPage />
                    </RequireRoles>
                  }
                />
<Route
                  path="/accounting/suite/period"
                  element={
                    <RequireRoles roles={['admin', 'owner', 'super_admin', 'accountant']}>
                      <Pages.PeriodCloseHubPage />
                    </RequireRoles>
                  }
                />
<Route path="/gst/e-invoices" element={<ProfileGstRoute kind="einvoice" />} />
<Route path="/gst/e-waybills" element={<ProfileGstRoute kind="ewaybill" />} />
<Route path="/gst/filing" element={<ProfileFilingRoute />} />
<Route path="/gst/gstr2b" element={<Pages.Gstr2bReconciliationPage />} />
<Route path="/gst/gstr9" element={<Pages.Gstr9Page />} />
<Route path="/finance/gst-filing" element={<ProfileFilingRoute />} />
<Route path="/purchase-invoices" element={<Pages.PurchaseInvoicesPage />} />
<Route path="/purchase-invoices/new" element={<Pages.PurchaseInvoiceEditor />} />
<Route path="/purchase-invoices/:id" element={<Pages.PurchaseInvoiceEditor />} />
<Route path="/ledger/vouchers" element={<ProfileVoucherRoute />} />
<Route path="/ledger/vouchers/:id" element={<ProfileVoucherRoute />} />
<Route path="/ledger/accounts/:accountId" element={<Pages.AccountLedger />} />
<Route path="/ledger/trial-balance" element={<Pages.TrialBalance />} />
<Route path="/ledger/profit-loss" element={<Pages.ProfitLoss />} />
<Route path="/ledger/balance-sheet" element={<Pages.BalanceSheet />} />
<Route path="/finance/invoice-swap" element={<Pages.InvoiceSwapPage />} />
<Route path="/finance/approvals" element={<ProfileHoldsRoute />} />
<Route path="/finance/dispatch-approvals" element={<Pages.DispatchApprovalsPage />} />
<Route path="/finance/security-deposits" element={<Pages.SecurityPaymentPage />} />
<Route path="/tally-export" element={<Pages.TallyExportPage />} />
{/*
  Dealer credit ledger (LOCKED SPEC 2026-09-23). Books/Money area: Accounts and
  admin read every dealer; a manager reads his own. The server is the authority
  (dealer-ledger.routes.ts) — this legacy role gate only keeps the page off an
  unrelated role's sidebar.
*/}
<Route
                  path="/dealer-ledger"
                  element={
                    <RequireRoles roles={DEALER_LEDGER_ROLES}>
                      <Pages.DealerLedgerListPage />
                    </RequireRoles>
                  }
                />
<Route
                  path="/dealer-ledger/:dealerId"
                  element={
                    <RequireRoles roles={DEALER_LEDGER_ROLES}>
                      <Pages.DealerStatementPage />
                    </RequireRoles>
                  }
                />
  </>;
}

export function ProfileHoldsRoute() { const { user } = useAuthStore(); return resolveProfile(user) === 'P06' ? <Pages.DispatchApprovalsPage initialTab="held" /> : <Pages.FinancialApprovalsListPage />; }
